import { render, staticRenderFns } from "./calendar-body.vue?vue&type=template&id=3c3d27bc&scoped=true"
import script from "./calendar-body.vue?vue&type=script&lang=js"
export * from "./calendar-body.vue?vue&type=script&lang=js"
import style0 from "./calendar-body.vue?vue&type=style&index=0&id=3c3d27bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3d27bc",
  null
  
)

export default component.exports